"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIncludedInList = void 0;
function isIncludedInList(list, key, value, isLower) {
    return ((list || []).findIndex((item) => {
        if (isLower) {
            if (item[key] && value) {
                return item[key].toLowerCase() === value.toLowerCase();
            }
            else {
                console.error('Error function isIncludedInList: item[key] or value is null');
                return null;
            }
        }
        else {
            return item[key] === value;
        }
    }) !== -1);
}
exports.isIncludedInList = isIncludedInList;
//# sourceMappingURL=isIncludedInList.js.map